import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import superAdminApis from '../../api/services/admin-pages/superAdmin';
import { toast } from 'react-toastify';
import translations from '../../shared/Translations';
import './index.css'

function AddInvestor() {

      const navigate = useNavigate();

          const [lang, setLang] = useState("en");
 const t = (key) => translations[lang][key] || key;

 useEffect(() => {
    const savedLang = localStorage.getItem("lang");
    if (savedLang) setLang(savedLang);
  }, []);


    const [additionalData, setAdditionalData] = useState([]);
    const [loading, setLoading] = useState(false)
      const [currentPage, setCurrentPage] = useState(1);
      const [recordsPerPage] = useState(10);
      const [totalRecords, setTotalRecords] = useState(0);
      const [isEditing,setIsEditing] = useState(false)
      const [investorId,setInvestorDeleteId] = useState("")
      const [intrestName,setIntrestName] = useState("")
      const [takenData, setTakenData] = useState([]);
      const [lessData, setLessData] = useState([]);
      const [submit,setSubmit] = useState(false)
      const [remaining,setRemaining] =useState(0)

      const [remainingObj, setRemainingObj] = useState({});


const [loadingTaken, setLoadingTaken] = useState(false);
const [loadingLess, setLoadingLess] = useState(false);
const [takenTotalRecords, setTakenTotalRecords] = useState(0);
const [lessTotalRecords, setLessTotalRecords] = useState(0);

const [isAdditionalPay, setIsAdditionalPay] = useState(false);


const [takenCurrentPage, setTakenCurrentPage] = useState(1);
const [lessCurrentPage, setLessCurrentPage] = useState(1);

useEffect(() => {
  if (!additionalData || additionalData.length === 0) return;

  const tmp = {};

  additionalData.forEach((item) => {
    const intrest = Number(item.amount) || 0;
    const paid = Number(item.pay_amount) || 0;
    tmp[item.id] = intrest - paid;
  });

  setRemainingObj(tmp);
}, [additionalData]);


        useEffect(() => {
        handleInvestorList(currentPage);
        handleTakenList(takenCurrentPage)
        handleLessList(lessCurrentPage)
        }, [currentPage,lessCurrentPage,takenCurrentPage]);

  const weekDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
      

   const [form, setForm] = useState({
  name: "",
  date: "",
  amount: "",
  rate: "",
  intrestamount : "" ,
  payMethod: "",
  payDuration: "",
  gpayNumber: "",     
  phonePeNumber: "",  
  bankName: "",   
  ifsccode : "" , 
  accountNumber: "",
weekDay: "",
payAmount : "" ,
payDate : ""

});


      const handleChange = (e) => {
  setForm({ ...form, [e.target.name]: e.target.value });
};

const totalPages = Math.ceil(totalRecords / recordsPerPage);
const takenTotalPages = Math.ceil(takenTotalRecords / recordsPerPage);
const lessTotalPages = Math.ceil(lessTotalRecords / recordsPerPage);

console.log(lessTotalPages);



const handlePageChange = (page) => {
  if (page < 1 || page > totalPages) return; 
  setCurrentPage(page);
};

const handleTakenPageChange = (page) => {
  if (page < 1 || page > takenTotalPages) return;
  setTakenCurrentPage(page);
};

const handleLessPageChange = (page) => {
  if (page < 1 || page > lessTotalPages) return;
  setLessCurrentPage(page);
};

    

   const handleBackCustomer = () => {
      navigate('/dashboard') 
    }


    // Investor List Crud
 const handleInvestorList = (page ) => {
  setLoading(true);

  const apiData = {
    pageIndex: page - 1,
    dataLength: recordsPerPage ?? 10,
  };

  superAdminApis.investorList(apiData)
    .then((responseData) => {
      if (responseData?.apiStatus?.code === "200") {
        setAdditionalData(responseData?.result?.investorDetails || []);
        setTotalRecords(responseData?.result?.totalRecordCount || 0);
      } else {
        setAdditionalData([]);
      }
      setLoading(false);
    })
    .catch(() => {
      setLoading(false);
      toast.error("An error occurred");
    });
};


const handleEdit = (item) => {
  setIsEditing(true);

  console.log(item);

  setForm({
    id: item.id,
    name: item.name,
    date: item.date,
    amount: item.amount,
    rate: item.intrest_rate,
    intrestamount: item.intrest_amount || "",
    payMethod: item.pay_method || "",
    payDuration: item.pay_duration || "",
    gpayNumber: item.gpay_number || "",
    phonePeNumber: item.phonepe_number || "",
    bankName: item.bank_name || "",
  ifsccode: item.ifsc_code,  
    accountNumber: item.account_number || "",
    weekDay : item.week_day ,
// payAmount: item.pay_amount || "",
//     payDate: item.pay_date || "",
  });

  // Check for additional pay
  // if (item.pay_amount || item.pay_date) {
  //   setIsAdditionalPay(true);
  // } else {
  //   setIsAdditionalPay(false);
  // }
  // setIsAdditionalPay(item.pay_amount || item.pay_date ? true : false);


  const modal = new window.bootstrap.Modal(
    document.getElementById("addinvestor")
  );
  modal.show();
};




    //   Add investor

const handleInvestorSubmit = async (e) => {
  e.preventDefault();
  setSubmit(true)

  if(!form.date) {
    return;
  }

  const apiData = {
    id: isEditing ? form.id : "", 
    name: form.name,
    date: form.date,
    amount: form.amount,
    intrest_rate: form.rate,
    intrest_amount : form.intrestamount,
    pay_method : form.payMethod,
    pay_duration : form.payDuration,
    gpay_number :form.gpayNumber,
    phonepe_number :form.phonePeNumber,
    bank_name : form.bankName,
    ifsc_code : form.ifsccode,
    account_number : form.accountNumber,
    week_day : form.weekDay,
    pay_amount :form.payAmount ,
    pay_date :form.payDate 
  };

  // Correct API call order
  const response = isEditing
    ? await superAdminApis.investorUpdateAPI(apiData)   
    : await superAdminApis.investorCreate(apiData);     

  if (response?.apiStatus?.code === "200") {
    toast.success(response.apiStatus.message);
  setSubmit(false)

    // Refresh table
    handleInvestorList();

    // Close modal
    document.getElementById("closedeleteModal").click();

    // Reset form
    setForm({
       name: "",
  date: "",
  amount: "",
  rate: "",
  intrestamount : "" ,
  payMethod: "",
  payDuration: "",
  gpayNumber: "",     
  phonePeNumber: "",  
  bankName: "",   
  ifsccode : "" , 
  accountNumber: "",
weekDay: "",
payAmount : "" ,
payDate : ""
    });

    setIsEditing(false);

  } else {
    toast.error("Failed");
  }
};


  const handleDeleteInvestor = () => {
         superAdminApis.investerDeleteAPI(investorId)
            .then((responseData) => {
               if (responseData.apiStatus.code === '200') {
                  const newTotalRecords = totalRecords - 1;
                  setTotalRecords(newTotalRecords);
                  let totalPages = Math.ceil(newTotalRecords / recordsPerPage);
                  if (currentPage > totalPages) {
                     setCurrentPage(totalPages || 1); 
                  }
                  else if (currentPage < 1) {
                     setCurrentPage(1);
                  }
                  const closeButton = document.getElementById("closedeleteModals");
                  if (closeButton) {
                     handleInvestorList(currentPage);
                     closeButton.click();
                  }
                  toast.success(responseData?.apiStatus?.message);
               } else {
                  toast.error(responseData?.apiStatus?.message);
               }
            })
            .catch((error) => {
               setLoading(false)
               console.error("Error during login:", error);
               toast.error("An error occurred during login.");
            });
      };


const handleTakenList = (page) => {
  setLoadingTaken(true);

  const apiData = {
    pageIndex: page - 1,
    dataLength: recordsPerPage,
  };

  superAdminApis.takenAmountList(apiData)
    .then((responseData) => {
      setLoadingTaken(false);
      if (responseData?.apiStatus?.code === "200") {
        setTakenData(responseData?.result?.takenAmountDetails || []);
        setTakenTotalRecords(responseData?.result?.totalRecordCount || 0);
      } else {
        setTakenData([]);
      }
    });
};

  
const handleDeleteTaken = () => {
  superAdminApis.takenDeleteAPI(investorId)
    .then((responseData) => {
      if (responseData.apiStatus.code === "200") {

        const newTotal = takenTotalRecords - 1;
        setTakenTotalRecords(newTotal);

        const totalPages = Math.ceil(newTotal / recordsPerPage);

        if (takenCurrentPage > totalPages) {
          setTakenCurrentPage(totalPages || 1);
        }

        handleTakenList(takenCurrentPage);

        document.getElementById("takenclosedeleteModal")?.click();
        toast.success(responseData.apiStatus.message);
      }
    });
};



const handleLessList = (page) => {
  setLoadingLess(true);

  const apiData = {
    pageIndex: page - 1,
    dataLength: recordsPerPage,
  };

  superAdminApis.lessAmountList(apiData)
    .then((responseData) => {
      setLoadingLess(false);
      if (responseData?.apiStatus?.code === "200") {
        setLessData(responseData?.result?.lessAmountDetails || []);
        setLessTotalRecords(responseData?.result?.totalRecordCount || 0);
      } else {
        setLessData([]);
      }
    });
};

  
const handleDeleteLess = () => {
  superAdminApis.lessDeleteAPI(investorId)
    .then((responseData) => {
      if (responseData.apiStatus.code === "200") {

        const newTotal = lessTotalRecords - 1;
        setLessTotalRecords(newTotal);

        const totalPages = Math.ceil(newTotal / recordsPerPage);

        if (lessCurrentPage > totalPages) {
          setLessCurrentPage(totalPages || 1);
        }

        handleLessList(lessCurrentPage);

        document.getElementById("lessclosedeleteModal")?.click();
        toast.success(responseData.apiStatus.message);
      }
    });
};


const closeClick = () => {
    setForm({
       name: "",
  date: "",
  amount: "",
  rate: "",
  intrestamount : "" ,
  payMethod: "",
  payDuration: "",
  gpayNumber: "",     
  phonePeNumber: "",  
  bankName: "",   
  ifsccode : "" , 
  accountNumber: "",
weekDay: "",
payAmount : "" ,
payDate : ""
    });

    setIsEditing(false);
}


  return (
    <div>
      <div className="d-flex justify-content-between align-items-center mt-3 mb-4">
        <nav aria-label="breadcrumb" className={lang === "ta" ? "fs-tamil" : ""}>
          <ol className="breadcrumb mb-0">
            <li className="breadcrumb-item">
              <a href="#" onClick={handleBackCustomer}>
                {t("dashboard")}
              </a>
            </li>
            <li className="breadcrumb-item active">Investor Details</li>
          </ol>
        </nav>

        <div className="d-flex gap-3">
   

    <button className="btn add-customer" onClick={handleBackCustomer}>
      <i className="fa fa-arrow-left me-2"></i> Back
    </button>

     <button className="btn add-customer" data-bs-toggle="modal"
      data-bs-target="#addinvestor">
      <i className="fa fa-plus me-2"></i> Add Invester
    </button>
  </div>

      </div>

 <div className='customer-list-container card'>

  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-2 mb-3">
  <h5 className={`heading-with-line  mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
  Investors List
    <span className="smooth-line"></span>
  </h5>
  </div>
     <div className='table-section'>
 <table className=" table-bordered">
        <thead className="table-light">
      <tr>
        <th>Name</th>
        <th>Date</th>
        <th>Amount</th>
        <th>Interest</th>
        <th>Pay Method</th>
        <th>Pay Duration</th>
        
        
        <th className="text-center">Actions</th>
      </tr>
    </thead>
   <tbody>
  {loading ? (
    <tr>
      <td colSpan="10" className="text-center py-4">
        <div className="gold-dots-loader">
          <div></div><div></div><div></div>
        </div>
      </td>
    </tr>
  ) : additionalData.length === 0 ? (
    <tr>
      <td colSpan="10" className="text-center py-3 text-muted">
        No Data Found
      </td>
    </tr>
  ) : (
    additionalData.map((item, i) => {
      return (
        <tr key={i}>
          <td style={{ whiteSpace: "nowrap" }}>{item.name || "-"}</td>

          {/* FIXED DATE */}
          <td style={{ whiteSpace: "nowrap" }}>
            {item.date ? item.date.split("-").reverse().join("-") : "-"}
          </td>

          <td style={{ whiteSpace: "nowrap" }}>{item.amount || "-"}</td>
          <td>{item?.intrest_amount||'-'}</td>

          <td>{item.pay_method || "-"}</td>
          <td>{item.pay_duration || "-"}</td>

          <td className="text-center">
            <div className="d-flex justify-content-center gap-2">

              <button
                onClick={() => handleEdit(item)}
                className="btn-view add-edit-btn"
                data-tooltip="Edit"
              >
                ✏️
              </button>

              <button
                className="btn-view delete-btn"
                data-tooltip="Delete"
                data-bs-toggle="modal"
                data-bs-target="#investorDelete"
                onClick={() => {
                  setInvestorDeleteId(item?.id);
                  setIntrestName(item?.name);
                }}
              >
                🗑️
              </button>

            </div>
          </td>
        </tr>
      );
    })
  )}
</tbody>

  </table>
  <div className="pagination-container text-right justify-content-end  mt-2">
  <button
    className="page-btn"
    onClick={() => handlePageChange(1)}
    disabled={currentPage === 1}
  >
    &laquo;
  </button>

  <button
    className="page-btn"
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
  >
    &lt;
  </button>

  {/* Render page numbers */}
  {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((page) => (
    <button
      key={page}
      className={`page-btn ${currentPage === page ? 'active' : ''}`}
      onClick={() => handlePageChange(page)}
    >
      {page}
    </button>
  ))}

  <button
    className="page-btn"
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
  >
    &gt;
  </button>

  <button
    className="page-btn"
    onClick={() => handlePageChange(totalPages)}
    disabled={currentPage === totalPages}
  >
    &raquo;
  </button>
</div>
</div>


{/* Investor Remainder Amt List */}
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 mb-3">
  <h5 className={`heading-with-line mb-2 mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
  Investors Remainder
    <span className="smooth-line"></span>
  </h5>
  </div>

      <div className='table-section'>
      <table className=" table-bordered">
        <thead className="table-light">
          <tr>
            <th>Name</th>
            <th>Date</th>
            <th>Expiry Date</th>
            <th>Total Amount</th>
            <th>Remaining Amount</th>
            <th>Remaining Days</th>
            <th>Status</th>
           
          </tr>
        </thead>
   <tbody>
  {loading ? (
    <tr>
      <td colSpan="10" className="text-center py-4">
        <div className="gold-dots-loader">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </td>
    </tr>
  ) : additionalData.length === 0 ? (
    <tr>
      <td colSpan="10" className="text-center text-muted py-3">
        No Data Found
      </td>
    </tr>
  ) : (

additionalData.map((item, i) => {
  let startDate = new Date(item.date);

  // If payment happened → reset startDate
  if (item.pay_date) {
    startDate = new Date(item.pay_date);
  }

  let expiryDate = new Date(startDate);
  let remainingDays = 0;
  const days = Number(remainingDays);


  // Add 7 days for weekly duration
  if (item.pay_duration === "Weekly") {
    expiryDate.setDate(startDate.getDate() + 7);
  } else {
    expiryDate.setDate(startDate.getDate() + 30);
  }

  // Remaining days calculation
  const today = new Date();
  const diffTime = expiryDate - today;
  remainingDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  // Remaining amount → amount - last paid amount
  const remainingAmount = item.amount - (item.pay_amount || 0);


  return (
    <tr key={i}>
      <td>{item.name}</td>

      {/* start date */}
      <td>
        {startDate && !isNaN(startDate)
          ? startDate.toISOString().split("T")[0].split("-").reverse().join("-")
          : ""}
      </td>

      {/* expiry date */}
      <td>
        {expiryDate && !isNaN(expiryDate)
          ? expiryDate.toISOString().split("T")[0].split("-").reverse().join("-")
          : ""}
      </td>

<td>{item?.amount}</td>
      {/* remaining amount */}
      <td>{remainingAmount}</td>

      {/* remaining days */}
      <td
   className={
  days === 0
    ? ""                 // 0 → normal
    : days === 1
    ? "blink-red"        // 1 → red blink
    : days <= 7
    ? "blink-yellow"     // 2–7 → yellow blink
    : ""
}


      >
        {remainingDays > 0 ? remainingDays : 0}
      </td>
   <td className="text-center align-middle">
  {remainingObj[item.id] === 0 ? (
    <span className="badge bg-primary">Finished</span>
  ) : (
    <span className="badge bg-success">Active</span>
  )}
</td>

    </tr>
  )
})


  )}
</tbody>





      </table>
      <div className="pagination-container text-right justify-content-end  mt-2">
  <button
    className="page-btn"
    onClick={() => handlePageChange(1)}
    disabled={currentPage === 1}
  >
    &laquo;
  </button>

  <button
    className="page-btn"
    onClick={() => handlePageChange(currentPage - 1)}
    disabled={currentPage === 1}
  >
    &lt;
  </button>

  {/* Render page numbers */}
  {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((page) => (
    <button
      key={page}
      className={`page-btn ${currentPage === page ? 'active' : ''}`}
      onClick={() => handlePageChange(page)}
    >
      {page}
    </button>
  ))}

  <button
    className="page-btn"
    onClick={() => handlePageChange(currentPage + 1)}
    disabled={currentPage === totalPages}
  >
    &gt;
  </button>

  <button
    className="page-btn"
    onClick={() => handlePageChange(totalPages)}
    disabled={currentPage === totalPages}
  >
    &raquo;
  </button>
</div>
    </div>


{/* Taken Amt List */}
  <div className="d-flex flex-column flex-md-row justify-content-between align-items-center mt-4 mb-3">
  <h5 className={`heading-with-line mb-2 mb-md-0 aquanew-text-effect ${lang === "ta" ? "fs-tamil" : ""}`}>
 Taken Amount List 
    <span className="smooth-line"></span>
  </h5>
  </div>

    <div className='table-section'>
      <table className="table-bordered">
        <thead className="table-light">
          <tr>
            <th>Sl No</th>
            <th>Date</th>
            <th>Time</th>
            <th>Amount</th>
            <th className='text-center'>Action</th>
           
          </tr>
        </thead>
    <tbody>
  {loadingTaken ? (
    <tr>
      <td colSpan="5" className="text-center py-4">
        <div className="gold-dots-loader">
          <div></div><div></div><div></div>
        </div>
      </td>
    </tr>
  ) : takenData.length === 0 ? (
    <tr>
      <td colSpan="5" className="text-center text-muted py-3">
        No Data Found
      </td>
    </tr>
  ) : (
     takenData.map((item, i) => {

   const parts = item.created_date.split(" ");

   const datePart = parts[0];          // 2025-12-01
   const timeFull = parts[1];          // 2:58:40
   const ampm = parts[2];              // PM

   // Convert 2025-12-01 → 01-12-2025
   const formattedDate = datePart?.split("-").reverse().join("-");

   // Convert 2:58:40 → 2:58
const shortTime = (timeFull?.slice(0, 5) || "") + " " + ampm;

   return (
     <tr key={i}>
      <td scope="row">{(takenCurrentPage - 1) * recordsPerPage + i + 1}</td>
       <td>{formattedDate || '-'}</td>
       <td>{shortTime || '-'}</td>
       <td>{item.taken_amount || '-'}</td>
       <td className="text-center">
         <div className="d-flex justify-content-center gap-2">

           <button
             className="btn-view delete-btn"
             data-tooltip="Delete"
             data-bs-toggle="modal"
             data-bs-target="#takenDelete"
             onClick={() => {
               setInvestorDeleteId(item?.id);
               setIntrestName(item?.name);
             }}
           >
             🗑️
           </button>

         </div>
       </td>
     </tr>
   );
 })

  )}
</tbody>




      </table>
      <div className="pagination-container text-right justify-content-end mt-2">
  <button
    className="page-btn"
    onClick={() => handleTakenPageChange(1)}
    disabled={takenCurrentPage === 1}
  >
    &laquo;
  </button>

  <button
    className="page-btn"
    onClick={() => handleTakenPageChange(takenCurrentPage - 1)}
    disabled={takenCurrentPage === 1}
  >
    &lt;
  </button>

  {/* Render page numbers */}

  {Array.from({ length: takenTotalPages }, (_, idx) => idx + 1).map((page) => (
    <button
      key={page}
      className={`page-btn ${takenCurrentPage === page ? 'active' : ''}`}
      onClick={() => handleTakenPageChange(page)}
    >
      {page}
    </button>
  ))}

  <button
    className="page-btn"
    onClick={() => handleTakenPageChange(takenCurrentPage + 1)}
    disabled={takenCurrentPage === takenTotalPages}
  >
    &gt;
  </button>

  <button
    className="page-btn"
    onClick={() => handleTakenPageChange(takenTotalPages)}
    disabled={takenCurrentPage === takenTotalPages}
  >
    &raquo;
  </button>
</div>
    </div>

 </div>




         {/* Add investor modal */}

 <div
        className="modal fade"
        id="addinvestor"
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
<div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header text-white" style={{background:"#7FB77E"}}>
              <h6 className="modal-title" id="deleteModalLabel">
                Add Investor
              </h6>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closedeleteModal"
                 onClick={closeClick}
              ></button>
            </div>

            <div className="modal-body ">
               <div className="row border-input-hover">

          <div className="col-md-6">
            <div className="form-group mt-2">
              <label>Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={form.name}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mt-2">
              <label className='form-label required-star'>Date</label>
              <input
                type="date"
                name="date"
                className="form-control"
                value={form.date}
                onChange={handleChange}
                  onClick={(e) => {
        const input = e.currentTarget;
        if (typeof input.showPicker === "function") {
          input.showPicker(); 
        } else {
          input.focus(); 
        }
      }}
       style={
        submit && form.date.length === 0
          ? { borderColor: "red" }
          : {}
      }
              />
               {submit && form.date.length === 0 && (
      <div className="text-danger">Date is required</div>
    )}
            </div>
          </div>

          <div className="col-md-6">
            <div className="form-group mt-2">
              <label>Amount</label>
              <input
                type="number"
                 onWheel={(e) => e.preventDefault()} 
                name="amount"
                className="form-control"
                value={form.amount}
                onChange={handleChange}
              />
            </div>
          </div>

       

           {/* <div className="col-md-6">
            <div className="form-group mt-2">
              <label>Interest Rate (%)</label>
              <select
                name="rate"
                className="form-control"
                value={form.rate}
                onChange={handleChange}
              >
                <option value="">Select Rate</option>
                <option value="2">2%</option>
                <option value="2.5">2.5%</option>
                <option value="3">3%</option>
              </select>
            </div>
          </div> */}

             <div className="col-md-6">
            <div className="form-group mt-2">
              <label>Interest</label>
               <input
                type="number"
                 onWheel={(e) => e.preventDefault()} 
                name="intrestamount"
                className="form-control"
                value={form.intrestamount}
                onChange={handleChange}
              />
            </div>
          </div>

            <div className="col-md-6">
  <div className="form-group mt-2">
    <label>Pay Method</label>
    <select
      name="payMethod"          
      className="form-control"
      value={form.payMethod}
      onChange={handleChange}
    >
      <option disabled value="">Select Method</option>
      <option value="gpay">GPay</option>
      <option value="phonepe">PhonePe</option>
      <option value="cash">Cash</option>
      <option value="account">Account Number</option>
    </select>
  </div>
</div>


             <div className="col-md-6">
            <div className="form-group mt-2">
              <label>Pay Duration</label>
              <select
                name="payDuration"
                className="form-control"
                value={form.payDuration}
                onChange={handleChange}
              >
                <option disabled value="">Select Duration</option>
                <option value="Weekly">Weekly</option>

                <option value="Weekly">Weekly</option>
                <option value="Monthly">Monthly</option>
              </select>
            </div>
          </div>

  {/* {form.payDuration === "Weekly" && (
  <><div className="col-md-6">
                    <div className="form-group mt-2">
                      <label>Select Day</label>
                      <select
                        name="weekDay"
                        className="form-control"
                        value={form.weekDay}
                        onChange={handleChange}
                      >
                        <option disabled value="">Select Day</option>
                        {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                          <option key={day} value={day}>{day}</option>
                        ))}
                      </select>
                    </div>
                  </div><div className="col-md-6">

                    </div></>
)} */}

  {form.payMethod === "gpay" && (
  <div className="col-md-6 mt-2">
    <div className="form-group">
      <label>GPay Number</label>
      <input
        type="text"
        name="gpayNumber"
        className="form-control"
        placeholder="Enter GPay Number"
        value={form.gpayNumber || ""}
        onChange={handleChange}
      />
    </div>
  </div>
)}

{form.payMethod === "phonepe" && (
  <div className="col-md-6 mt-2">
    <div className="form-group">
      <label>PhonePe Number</label>
      <input
        type="text"
        name="phonePeNumber"
        className="form-control"
        placeholder="Enter PhonePe Number"
        value={form.phonePeNumber || ""}
        onChange={handleChange}
      />
    </div>
  </div>
)}

{form.payMethod === "account" && (
  <>
    <div className="col-md-4 mt-2">
      <div className="form-group">
        <label>Bank Name</label>
        <input
          type="text"
          name="bankName"
          className="form-control"
          placeholder="Enter Account Name"
          value={form.bankName || ""}
          onChange={handleChange}
        />
      </div>
    </div>
    <div className="col-md-4 mt-2">
      <div className="form-group">
        <label>IFSC Code</label>
        <input
          type="text"
          name="ifsccode"
          className="form-control"
          placeholder="Enter IFSC code Number"
  value={form.ifsccode || ""}
          onChange={handleChange}
        />
      </div>
    </div>
    <div className="col-md-4 mt-2">
      <div className="form-group">
        <label>Account Number</label>
        <input
          type="text"
          name="accountNumber"
          className="form-control"
          placeholder="Enter Account Number"
          value={form.accountNumber || ""}
          onChange={handleChange}
        />
      </div>
    </div>
  </>
)}


{/* Pay Method */}

<div className="form-group mt-4">
                <label className="form-label">🟡 Do you want to pay investor amount ? </label>

                <label className="switch">
                  <input
                    type="checkbox"
                    checked={isAdditionalPay}
                    onChange={(e) => setIsAdditionalPay(e.target.checked)} />
                  <span className="slider round"></span>
                </label>
              </div>

      
              {isAdditionalPay && (
  
  <div className='row'>
    <div className='col-md-6'>
 <div className="form-group mt-2">
 <label>Pay Investor Amount</label>
      <input
        type="number"
         onWheel={(e) => e.preventDefault()} 
        name='payAmount'
        className="form-control"
        value={form.payAmount}
placeholder={`Investor balance amount: ₹${(form.amount - (remainingObj[form.id] || 0))}`}
        onChange={handleChange}
      />
  </div>
  </div>

<div className='col-md-6'>
 <div className="form-group mt-2">
   <label>Pay Date</label>
      <input
        type="date"
         onWheel={(e) => e.preventDefault()} 
        name='payDate'
        className="form-control"
        value={form.payDate}
         onClick={(e) => {
        const input = e.currentTarget;
        if (typeof input.showPicker === "function") {
          input.showPicker(); // Chrome/Edge
        } else {
          input.focus(); // Safari fallback
        }
      }}
       
        onChange={handleChange}
      />
  </div>
  </div>

</div>
  )}        
    
        </div>
            </div>

            <div className="modal-footer justify-content-center ">
      
            
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={closeClick}
              >
                Cancel
              </button>
                        <div className='all-btn-color'>
  <button
                type="button"
                className="btn add-customer"
                onClick={handleInvestorSubmit}
              >
                Submit
              </button>
                </div>
            </div>
          </div>
        </div>
</div>



      {/*Investor Delete Modal */}

   <div
        className="modal fade"
        id="investorDelete"
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteModalLabel">
                Confirm Delete
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="closedeleteModals"
              ></button>
            </div>

            <div className="modal-body text-center">
              Are you sure you want to delete this investor <span className='delete-customer-name'>{intrestName}</span>  ?
            </div>

            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDeleteInvestor}
              >
                Yes, Delete
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
    </div>


          {/*Taken Delete Modal */}

   <div
        className="modal fade"
        id="takenDelete"
        tabIndex="-1"
        aria-labelledby="deleteModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteModalLabel">
                Confirm Delete
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                id="takenclosedeleteModal"
              ></button>
            </div>

            <div className="modal-body text-center">
              Are you sure you want to delete this taken ?
            </div>

            <div className="modal-footer justify-content-center">
              <button
                type="button"
                className="btn add-customer"
                onClick={handleDeleteTaken}
              >
                Yes, Delete
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>


    </div>
  )
}

export default AddInvestor
